
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenges",
      function () {
        return require("private-next-pages/challenges/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/challenges"])
      });
    }
  